import { RootSelector } from "./RootSelector";
import { SortSelector } from "./SortSelector";
import { ViewSelector } from "./ViewSelector";
import { VisibilitySelector } from "./VisibilitySelector";
import { useControlsDropdownContext } from "./context";

export const Renderer = () => {
  const { currentComponent } = useControlsDropdownContext();
  switch (currentComponent) {
    case "visibility":
      return <VisibilitySelector />;
    case "sort":
      return <SortSelector />;
    case "view":
      return <ViewSelector />;
    case "root":
      return <RootSelector />;
    default:
      return null;
  }
};
